import { ComponentType } from 'react'

import { Post } from './types'

import { postsManifest } from '@/generated/posts-manifest'

interface PostModule {
  default: ComponentType<Record<string, unknown>>
}

const postComponentLoaders = import.meta.glob('../pages/posts/*.mdx') as Record<string, () => Promise<PostModule>>

const slugToFilePath = new Map<string, string>()

for (const filePath of Object.keys(postComponentLoaders)) {
  const slug = filePath
    .split('/')
    .pop()
    ?.replace(/\.mdx$/, '')

  if (!slug) {
    continue
  }

  slugToFilePath.set(slug, filePath)
}

export const getPosts = () => {
  return [...postsManifest].sort((a, b) => b.data.created.localeCompare(a.data.created))
}

export const getPostBySlug = (slug: string): Post | null => {
  return postsManifest.find(post => post.slug === slug) ?? null
}

export const getPostComponentLoader = (slug: string): (() => Promise<PostModule>) | null => {
  const filePath = slugToFilePath.get(slug)

  if (!filePath) {
    return null
  }

  const loader = postComponentLoaders[filePath]

  if (!loader) {
    return null
  }

  return loader
}
